<template>
  <template v-if="hasMobileAndDesktopLayouts">
    <template v-if="mq.mdPlus">
      <component
        :is="component(item)"
        v-for="(item, index) in pageContent.desktop"
        :key="index"
        v-bind="item.props"
        :style="item.style"
      >
        <template v-for="(slot, key) in slotContent(item)" #[key] :key="key">
          <component
            :is="component(element)"
            v-for="(element, elementIndex) in slot"
            :key="elementIndex"
            v-bind="slotElementProps(element)"
            :class="element.class"
            :style="element.style"
          >
            {{ slotElementText(element) }}
          </component>
        </template>
      </component>
    </template>

    <template v-else>
      <component
        :is="component(item)"
        v-for="(item, index) in pageContent.mobile"
        :key="index"
        v-bind="item.props"
        :style="item.style"
      >
        <template v-for="(slot, key) in slotContent(item)" #[key] :key="key">
          <component
            :is="component(element)"
            v-for="(element, elementIndex) in slot"
            :key="elementIndex"
            v-bind="slotElementProps(element)"
            :class="element.class"
            :style="element.style"
          >
            {{ slotElementText(element) }}
          </component>
        </template>
      </component>
    </template>
  </template>
  <template v-else>
    <component
      :is="component(item)"
      v-for="(item, index) in pageContent.content"
      :key="index"
      v-bind="item.props"
      :style="item.style"
    >
      <template v-for="(slot, key) in slotContent(item)" #[key] :key="key">
        <component
          :is="component(element)"
          v-for="(element, elementIndex) in slot"
          :key="elementIndex"
          v-bind="slotElementProps(element)"
          :class="element.class"
          :style="element.style"
        >
          {{ slotElementText(element) }}
        </component>
      </template>
    </component>
  </template>
</template>

<script>
import { defineAsyncComponent } from "vue";
import {
  loadContentJson,
  slotElementProps,
  slotElementText,
} from "@/helpers/content.js";

export default {
  name: "BrandWorldPage",
  inject: ["mq"],
  props: {
    pageHandle: {
      type: String,
      default: null,
    },
  },
  computed: {
    resolvedPageHandle() {
      if (this.pageHandle) {
        return this.pageHandle;
      }

      const match = window.location.pathname.match(/\/pages\/([^/?#]+)/);
      return match?.[1] || "";
    },
    pageContent() {
      try {
        return loadContentJson(`brand-world/${this.resolvedPageHandle}`);
      } catch (error) {
        console.error(
          `[BrandWorldPage] Failed to load content for handle "${this.resolvedPageHandle}"`,
          error
        );
        return { content: [] };
      }
    },
    hasMobileAndDesktopLayouts() {
      return (
        Object.prototype.hasOwnProperty.call(this.pageContent, "mobile") &&
        Object.prototype.hasOwnProperty.call(this.pageContent, "desktop")
      );
    },
  },
  methods: {
    component(content) {
      if (content.tag) {
        return content.tag;
      }

      return defineAsyncComponent(() =>
        import(
          /* webpackChunkName: "[request]" */ `@/components/${content.component}.vue`
        )
      );
    },
    slotContent(item) {
      return item.slot;
    },
    slotElementText,
    slotElementProps,
  },
};
</script>
